import { createContext, useContext } from 'react';
import type { Session } from '@/shared/auth/session';

export interface AuthContextValue {
  /** Sessão ativa (credencial + operador), ou `null` quando deslogado. */
  session: Session | null;
  /** Mensagem a exibir na tela de login depois de uma expiração automática. */
  expirationNotice: string | null;
  signIn: (session: Session) => void;
  signOut: () => void;
  dismissExpirationNotice: () => void;
}

/**
 * O contexto fica em arquivo próprio (separado do provider) para que os módulos
 * que só consomem o hook não importem o componente — mantém o Fast Refresh
 * previsível e evita ciclos de import.
 */
export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de <AuthProvider>.');
  }
  return context;
}

/** Sessão garantida — para telas que só renderizam autenticadas. */
export function useSession(): Session {
  const { session } = useAuth();
  if (!session) {
    throw new Error('useSession requer uma sessão ativa.');
  }
  return session;
}
